import React from 'react';
import { Helmet } from 'react-helmet';
import PageNavigation from './PageNavigation';
import Title from '../../components/Title';
import { Outlet } from 'react-router-dom';

export default function UserCommunicationPage() {
    return (
        <div>
            <Helmet>
                <title>Console Defentry - User communication</title>
            </Helmet>
            <Title>User communication</Title>
            <div className="navigation-tabs__bottom-indent-wrapper--32">
                <PageNavigation />
            </div>
            <Outlet />
        </div>
    );
}
